

























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {
  CHECKBOX_SINGLE_SELECTION_SERVICE,
  SingleSelectionInstance
} from '@/fields/checkbox/checkbox-single-selection.service';
import BindAttrs from '@/utils/binds-attrs';
import {HTML_SERVICE_INSTANCE} from '@/services/html.service';

/**
 * General Component for Fields of type CHECKBOX
 *
 * https://confluence.ametras.com/x/L4RQAw
 */
@Component({
  mixins: [BindAttrs]
})
export default class AmetrasCheckBoxTemplate extends Vue implements SingleSelectionInstance {
  @Prop() marginDefinition!: string;
  @Prop() paddingDefinition!: string;
  @Prop() textAlign!: 'LEFT' | 'RIGHT' | 'CENTER' | 'JUSTIFIED';
  @Prop() value!: string | number | boolean | null | undefined;
  @Prop() label!: string;
  // single selection group is a unique id across multiple checkboxes
  // if this id is specified and there is another checkbox rendered
  // all other checkboxes will be set to false if this is set to true
  @Prop({
    required: false,
    default: ''
  }) singleSelectionGroup!: string;
  /**
   * Indicates that we should render a simple mode of this component (increases the rendering performance)
   */
  @Prop() simple!: boolean;
  @Prop() readonly!: boolean;

  listeners: Record<string, any> = {};
  innerValue: boolean = false;

  $refs!: {
    inputfield: Vue
  };

  private originalClickListeners: any[] = [];

  @Watch('value') valueChanged(newValue: string | number | boolean | null | undefined) {
    this.innerValue = this.primitiveToBoolean(newValue);
  }

  @Watch('innerValue') innerValueChanged(newValue: boolean) {
    if (this.primitiveToBoolean(newValue) && this.singleSelectionGroup !== '') {
      CHECKBOX_SINGLE_SELECTION_SERVICE.unselectOthers(this.singleSelectionGroup, this);
    }
    if (newValue !== this.primitiveToBoolean(this.value)) {
      // publish only if different
      this.$emit('input', newValue);
    }
  }

  created() {
    this.innerValue = this.primitiveToBoolean(this.value);
    if (this.singleSelectionGroup !== '') {
      CHECKBOX_SINGLE_SELECTION_SERVICE.register(this.singleSelectionGroup, this);
    }

    if (this.$listeners.click) {
      if (Array.isArray(this.$listeners.click)) {
        this.originalClickListeners = this.originalClickListeners.concat(this.$listeners.click);
      } else {
        this.originalClickListeners.push(this.$listeners.click);
      }
    }
    this.listeners = {
      ...this.$listeners,
      click: (newValue: Event) => {
        for (const fnc of this.originalClickListeners) {
          fnc(newValue);
        }
        if (this.$refs.inputfield && this.$refs.inputfield.$el) {
          HTML_SERVICE_INSTANCE.focusFirstNode(this.$refs.inputfield.$el , true);
        }
      }
    };
  }

  destroyed() {
    if (this.singleSelectionGroup !== '') {
      CHECKBOX_SINGLE_SELECTION_SERVICE.unregister(this.singleSelectionGroup, this);
    }
  }

  primitiveToBoolean(value: string | number | boolean | null | undefined): boolean {
    if (value === 'true') {
      return true;
    }

    return typeof value === 'string'
        ? !!+value   // we parse string to integer first
        : !!value;
  }

  shouldUnselect(): void {
    this.valueChanged('false');
  }
}
